import { render, staticRenderFns } from "./slider-review-kynorelle.vue?vue&type=template&id=f5bd0bce&scoped=true&"
import script from "./slider-review-kynorelle.vue?vue&type=script&lang=js&"
export * from "./slider-review-kynorelle.vue?vue&type=script&lang=js&"
import style0 from "./slider-review-kynorelle.vue?vue&type=style&index=0&id=f5bd0bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd0bce",
  null
  
)

export default component.exports